import {
  ThicknessMax,
  ThicknessStep,
} from '../../../../../config/panelConfig';

export interface ChamberOverlayWheelRange {
  min: number;
  max: number;
  step: number;
}

export const CHAMBER_OVERLAY_WHEEL_RANGES = {
  thickness: {
    min: 0.2,
    max: ThicknessMax,
    step: ThicknessStep,
  },
  spacing: {
    min: 1.0,
    max: 10.0,
    step: 1.0,
  },
  imageSize: {
    min: 100.0,
    max: 240.0,
    step: 5.0,
  },
  additionalSlice: {
    min: -50.0,
    max: 50.0,
    step: 1.0,
  },
} satisfies Record<string, ChamberOverlayWheelRange>;

const clamp = (value: number, min: number, max: number) =>
  Math.min(max, Math.max(min, value));

export function getNextChamberOverlayWheelValue(
  currentValue: number | undefined,
  deltaY: number,
  range: ChamberOverlayWheelRange,
) {
  if (
    typeof currentValue !== 'number' ||
    !Number.isFinite(currentValue)
  ) {
    return undefined;
  }

  if (deltaY === 0) {
    return currentValue;
  }

  const direction = Math.sign(-deltaY);
  return clamp(currentValue + direction * range.step, range.min, range.max);
}
